import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const KEY = "tilesmate_builder_token";
export const getBuilderToken = () => localStorage.getItem(KEY);
export const setBuilderToken = (t) => { if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY); };

const builderClient = axios.create({ baseURL: API });
builderClient.interceptors.request.use((cfg) => {
  const t = getBuilderToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default builderClient;
